















































import Vue from 'vue'
import ActionButton from './ActionButton.vue'
export default Vue.extend({
  components: { ActionButton },
  props: {
    value: [String, Object, File],
    height: [String, Number],
    width: [String, Number],
  },
  data() {
    return {
      localModel: this.value,
    }
  },
  computed: {
    computedSrc(): string {
      if (typeof this.localModel === 'object') {
        try {
          return URL.createObjectURL(this.localModel)
        } catch {
          return ''
        }
      } else if (typeof this.localModel === 'string') return this.localModel
      return ''
    },
  },
  watch: {
    value(val: string | object) {
      this.localModel = val
    },
    localModel(val: string | object) {
      this.$emit('input', val)
    },
  },
  methods: {
    onClick() {
      const input = document.createElement('input')
      input.type = 'file'
      input.accept = 'image/*'
      input.oninput = ev => {
        const files = (ev.target as HTMLInputElement).files
        if (files) {
          this.localModel = files[0]
        }
      }
      input.click()
    },
    onDelete() {
      this.localModel = ''
    },
  },
})
